import type { ClientAnswer } from '@/api/orderDetails'

export const SURVEY_QUESTION_DISPLAY_NAMES: Record<string, { en: string; ar: string }> = {
  SN1: {
    en: 'Access notes for pickup location',
    ar: 'ملاحظات الوصول لموقعك',
  },
  LOC3: {
    en: 'Pickup Location',
    ar: 'موقع الاقلاع',
  },
  LOC4: {
    en: 'Dropoff Location',
    ar: 'موقع الانزال',
  },
  OBS1: {
    en: 'Is there anything else we should know to provide the best care?',
    ar: 'هل هناك أي شيء آخر يجب أن نعرفه لتقديم أفضل رعاية؟',
  },
  OBS2: {
    en: 'Are there any important medical notes we should know about?',
    ar: 'هل توجد أي ملاحظات طبية مهمة يجب أن نعرفها؟',
  },
  SN2: {
    en: 'Drop-off location accessibility notes',
    ar: 'ملاحظات الوصول لموقع الوجهة المطلوبة',
  },
}

function normalizeCode(code: string): string {
  return code.trim().toUpperCase()
}

export function extractBaseSurveyQuestionCode(code: string | null | undefined): string | null {
  if (code == null || typeof code !== 'string' || !code.trim()) return null
  const normalized = code.trim()
  const lower = normalized.toLowerCase()
  if (lower.includes('_service_')) {
    const prefix = normalized.split(/_service_/i)[0]?.trim() ?? normalized
    return normalizeCode(prefix)
  }
  return normalizeCode(normalized)
}

export function getDisplayNameForCode(code: string, locale: 'en' | 'ar'): string | null {
  if (!code) return null
  const key = extractBaseSurveyQuestionCode(code)
  if (!key) return null
  const entry = SURVEY_QUESTION_DISPLAY_NAMES[key]
  if (!entry) return null
  return locale === 'ar' ? entry.ar : entry.en
}

const CODE_SERVICE_UUID_REGEX = /^([A-Za-z0-9]+)\s+Service\s+[0-9a-f-]{36}$/i

export function getDisplayNameForInstanceOrServiceLabel(
  label: string | null,
  locale: 'en' | 'ar'
): string | null {
  if (label == null || typeof label !== 'string' || !label.trim()) return null
  const match = label.trim().match(CODE_SERVICE_UUID_REGEX)
  if (!match) return null
  return getDisplayNameForCode(match[1], locale)
}

export function getDisplayNameForGroup(
  _uuid: string,
  answers: ClientAnswer[],
  locale: 'en' | 'ar'
): string | null {
  if (!answers.length) return null
  const baseCodes = new Set(
    answers
      .map((a) => (a.questionCode ? extractBaseSurveyQuestionCode(a.questionCode) : null))
      .filter((c): c is string => Boolean(c))
  )
  if (baseCodes.size !== 1) return null
  const code = [...baseCodes][0]
  return getDisplayNameForCode(code, locale)
}
